export default __webpack_public_path__ + "static/media/opinion1.04e47136.jpg";